import * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from '../lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    dataTestId?: string;
  }
>(({ className, dataTestId, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'vai-peer vai-h-4 vai-w-4 vai-shrink-0 vai-rounded-sm vai-border vai-border-primary vai-shadow focus-visible:vai-outline-none focus-visible:vai-ring-1 focus-visible:vai-ring-ring disabled:vai-cursor-not-allowed disabled:vai-opacity-50 data-[state=checked]:vai-bg-primary data-[state=checked]:vai-text-primary-foreground',
      className,
    )}
    {...props}
    data-testid={dataTestId}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        'vai-flex vai-items-center vai-justify-center vai-text-current',
      )}
    >
      <Check className="vai-h-4 vai-w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
